const submissionStatus = {
    INVALID : 0,

    CREATED_APPLICATION : 1,

    CREATED : 1,

    SUBMITTED : 2,

    CLEARED : 3,

    CLEAR : 3,

    QUOTED : 4,

    BIND_REQUESTED : 5,

    BIND_CONFIRMED : 6,

    BOUND : 6,

    ISSUED : 7,

    CANNOT_BE_CLEARED : 8,

    NOT_CLEAR : 8,

    LOST : 9,

    DECLINED : 10,

    WITHDRAWN : 11,

    EXPIRED : 12,

    PENDING_ISSUANCE : 15,

    DECLINED_QUOTE : 16,

    CANCELLED : 18,

    CLEAR_AWAITING_RATE : 20,

    RENEWED : 21,

    NON_RENEWED : 22,

    SUBMIT_PENDING : 24,

    CLEAR_READY_TO_UNDERWRITE : 25,

    REJECTED : 26,

    CREATED_SUBMISSION : 27

};

angular.module('gw-um-j2js')
    .constant('submissionStatus', submissionStatus);